import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    component: () => import('./views/Login.vue'),
  },

  {
    path: '/cards',
    component: () => import('./views/Cards.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/archiveCards',
    component: () => import('./views/CardsArchive.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/kiosks',
    component: () => import('./views/Kiosks.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/banks',
    component: () => import('./views/Banks.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/users',
    component: () => import('./views/Users.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/roles',
    component: () => import('./views/Roles.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/devices',
    component: () => import('./views/Devices.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/devicesandproducts',
    component: () => import('./views/DevicesAndProducts.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/devicemonitoring',
    component: () => import('./views/DeviceMonitoring.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/products',
    component: () => import('./views/Products.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/branches',
    component: () => import('./views/Branches.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/eventLog',
    component: () => import('./views/EventLog.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/settings',
    component: () => import('./views/SettingsAdminForm.vue'),
    meta: {
      requiresAdminAuth: true,
    },
  },
  {
    path: '*',
    redirect: '/cards',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();

      return;
    }
    next('/login');
  }
  else if(to.matched.some((record) => record.meta.requiresAdminAuth)) {
    if (store.state.adminPassword) {
      next();

      return;
    }
    next('/cards');
  }
  else {
    if (to.query.mode != 'reset' && store.getters.isLoggedIn) next('/cards');
    else next();
  }
});

export default router;
